<template>
<div class="icon-name c-ndarkfour" :style="small ? 'height: 32px;width: 32px; font-size: 14px;' : ''">
    {{ initialName }}
</div>
</template>

<script>
export default {
    props: {
        name: {
            type: String
        },
        small: {
            type: Boolean
        }
    },
    computed: {
        initialName() {
            if (this.name) {
                const regex = new RegExp(/\W+/g)
                let nameSplit = this.name.trim().replace(regex, ' ').split(' ').filter(n => n);
                return nameSplit.length > 1 ? `${nameSplit[0][0]}${nameSplit[1][0]}` : `${nameSplit[0][0]}${nameSplit[0][1]}`
            } else {
                return '--'
            }
        }
    }
}
</script>

<style scoped>
.icon-name {
    height: 48px;
    width: 48px;
    background: #FBFDFE;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #DFE2EB;
    border-radius: 48px;
    float: left;
    margin-right: 16px;
    text-transform: uppercase;
}
</style>
